import React, { useState, useEffect } from 'react';
import { AlertTriangle, X } from 'lucide-react';

const AgeVerification = () => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    // Vérifier si l'utilisateur a déjà confirmé son âge
    const ageVerified = localStorage.getItem('ageVerified');
    if (!ageVerified) {
      setShowModal(true);
    }
  }, []);

  const handleConfirm = () => {
    localStorage.setItem('ageVerified', 'true');
    setShowModal(false);
  };

  const handleDecline = () => {
    // Rediriger vers une page d'avertissement ou fermer
    window.location.href = 'https://www.joueurs-info-service.fr';
  };

  if (!showModal) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 backdrop-blur-sm">
      <div className="glass-strong rounded-2xl p-8 md:p-12 max-w-md mx-4 border-2 border-red-500/50 relative">
        <div className="absolute top-4 right-4">
          <button
            onClick={handleDecline}
            className="text-white/60 hover:text-white transition-colors"
            aria-label="Fermer"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        <div className="flex flex-col items-center text-center">
          <div className="w-16 h-16 glass rounded-full flex items-center justify-center mb-6 border-2 border-red-500/50">
            <AlertTriangle className="w-8 h-8 text-red-400" />
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Vérification d'âge requise
          </h2>

          <p className="text-white/80 mb-6 leading-relaxed">
            Ce site concerne les paris sportifs en ligne, une activité réservée aux personnes majeures (18 ans et plus).
          </p>

          <p className="text-white/70 mb-8 text-sm leading-relaxed">
            En accédant à ce site, vous confirmez que vous avez au moins 18 ans et que vous êtes légalement autorisé à consulter 
            des informations sur les paris sportifs dans votre juridiction.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 w-full">
            <button
              onClick={handleDecline}
              className="px-6 py-3 glass border border-white/20 text-white font-semibold rounded-lg hover:bg-white/10 transition-all"
            >
              J'ai moins de 18 ans
            </button>
            <button
              onClick={handleConfirm}
              className="px-6 py-3 bg-gradient-to-r from-toxic-green to-toxic-cyan text-black font-bold rounded-lg hover:shadow-lg hover:shadow-toxic-green/50 transition-all"
            >
              J'ai 18 ans ou plus
            </button>
          </div>

          <p className="text-xs text-white/60 mt-6">
            Jeux d'argent et de hasard interdits aux mineurs
          </p>
        </div>
      </div>
    </div>
  );
};

export default AgeVerification;

